import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NgForm } from '@angular/forms';

import { AppService } from '../../services/app.service';
import { Router } from '@angular/router';
import { ActivatedRoute, Params } from '@angular/router';
import { FirmantesService } from 'src/app/services/firmantes/firmantes.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import Swal from 'sweetalert2';
import { LoginService } from 'src/app/services/login/login.service';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'app-firmantes',
  templateUrl: '../../pages/firmantes/firmantes.component.html',
  styleUrls: ['../../pages/firmantes/firmantes.component.css']
})

export class FirmantesComponent implements OnInit 
{
    options = { autoClose: true, keepAfterRouteChange: false };
    mensaje: boolean = false;
    mensajeError: string;
    agp:string = "0";
    nombreUsuario: string = localStorage.getItem("nombreUsuario");
    firmante: any = [{ usuarioFirmante: '', fechaFirma: '', rutFirmante: '',tipoFirma: ''} ]
    constructor(private appService: AppService, public router: Router, private dialog: MatDialog,
       private route: ActivatedRoute, private firmantesService:FirmantesService, private loginService:LoginService) { }

    ngOnInit(): void  
    { 
     
      let vm = this
      this.agp=this.route.snapshot.queryParams.agp
      let desencriptado
      try {
        desencriptado =  atob(this.agp)
    } catch(e) {
        this.openAlertDialog('El identificador ingresado no es correcto.', 'btn-dark')
        vm.router.navigate(['/index']) 
        return
    }
    this.traeFirmantes(desencriptado)
  
    }
    
    traeFirmantes(agpId: any)
    {  
        let vm = this
        Swal.fire({
          allowOutsideClick:false,
          icon:'info',
          text:'Cargando...'
        });
        Swal.showLoading();    
       

        this.firmantesService.traeFirmantes(agpId).then
        (
            response =>
            {
             
              vm.firmante = response
              Swal.close();               
            }
        )
        .catch ( error =>
        {
          let vm = this
          this.openAlertDialog('El identificador ingresado no tiene firmantes asociados.', 'btn-dark')
        //  vm.router.navigate(['/index']) 
          Swal.close();
      
        } )
    }

    openAlertDialog(mensaje: string, clase: string)
    {
        this.dialog.open(AlertDialogComponent, {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        })
    }

}
